import React from 'react';
import Icon from '@ant-design/icons';
import { ReactComponent as DeleteIconSvg }  from '../../assets/icons/icon_delete_blue.svg';

const DeleteIcon=(props)=>{
    return <Icon component={() => <DeleteIconSvg />} {...props}/>
}

export default DeleteIcon;